<template>
  <transition name="fade">
  <div class="flash">
    <div class="msg"><slot></slot></div>
  </div>
  </transition>
</template>

<style scoped>
  .flash {
    width: 100px;
    height: 100px;
    text-align: center;
    background: #000000aa;
    color: white;
    padding: 10px;
    position: absolute;
    left: calc(50% - 50px);
    top: calc(50% - 50px);
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }
  /* animation */
  .fade-enter-active, .fade-leave-active {
    transition: all 300ms 0.15s cubic-bezier(.36,.93,.79,1.52);
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: scale(1.6);
  }
</style>

<script>
import * as atypes from '@/store/action-types'
export default {
  name: 'Flash',
  mounted () {
    window.setTimeout(() => {
      this.$store.dispatch(atypes.FLASH_CLEAR_MSG)
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Flash.vue